import api from './api'

export const newsService = {
  // Récupérer toutes les actualités
  getAll: (page = 1, limit = 10, published = null) => {
    const params = new URLSearchParams({ page, limit })
    if (published !== null) {
      params.append('published', published)
    }
    return api.get(`/api/news?${params.toString()}`)
  },

  // Récupérer une actualité par ID
  getById: (id) => {
    return api.get(`/api/news/${id}`)
  },

  // Récupérer une actualité par slug
  getBySlug: (slug) => {
    return api.get(`/api/news/slug/${slug}`)
  },

  // Créer une nouvelle actualité
  create: (newsData) => {
    const formData = new FormData()
    
    formData.append('title', newsData.title)
    formData.append('slug', newsData.slug)
    formData.append('summary', newsData.summary || '')
    formData.append('content', JSON.stringify(newsData.content))
    formData.append('isPublished', newsData.isPublished ? 'true' : 'false')
    
    if (newsData.coverImage) {
      formData.append('coverImage', newsData.coverImage)
    }

    return api.post('/api/news', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Mettre à jour une actualité
  update: (id, newsData) => {
    const formData = new FormData()
    
    formData.append('title', newsData.title)
    formData.append('slug', newsData.slug)
    formData.append('summary', newsData.summary || '')
    formData.append('content', JSON.stringify(newsData.content))
    formData.append('isPublished', newsData.isPublished ? 'true' : 'false')
    
    if (newsData.coverImage instanceof File) {
      formData.append('coverImage', newsData.coverImage)
    }

    return api.put(`/api/news/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Supprimer une actualité
  delete: (id) => {
    return api.delete(`/api/news/${id}`)
  },

  // Publier/Dépublier une actualité
  togglePublish: (id) => {
    return api.post(`/api/news/${id}/toggle-publish`)
  },

  // Upload une image pour le contenu
  uploadContentImage: (imageFile) => {
    const formData = new FormData()
    formData.append('image', imageFile)

    return api.post('/api/news/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Upload un média (vidéo, GIF)
  uploadMedia: (mediaFile, type = 'video') => {
    const formData = new FormData()
    formData.append('media', mediaFile)
    formData.append('type', type)

    return api.post('/api/news/upload-media', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Mettre à jour les médias d'une actualité
  updateMedia: (id, mediaData) => {
    return api.put(`/api/news/${id}/media`, mediaData)
  },
}

